export function objectsMerge<T extends {}>(...args: Readonly<Partial<T>>[]): T {
  return Object.assign({}, ...args);
}
